import { h, defineComponent } from 'vue'
import { useGlobals } from '@/main.js'
import store from '@/store/index.js'
import DateHeader from '../../HeaderCells/DateHeader.vue'

export const registerModifiedAtColumn = (dashboard, { visible } = { visible: true }) => {
  const { $format } = useGlobals()
  dashboard.registerCustomColumn({
    name: 'modified_at',
    label: 'monolith.shared.last_modified',
    component: defineComponent({
      setup(_ctx, { attrs }) {
        return () => h('span', attrs.value)
      },
    }),
    options: {
      format: $format.date,
      searchable: store.getters.getConfig.SHOW_DATE_FILTERS,
      headerComponent: DateHeader,
      visible,
    },
  })
}
